<template>
    <button class="btn btn-primary" @click="logout">{{$t('logout')}}</button>
</template>

<script>
export default {
    methods: {
        logout() {
            document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            this.$router.push('/login');
        }
    }
}
</script>